import { createAction, props } from '@ngrx/store';
import {
  ImportNotebookSocketSuccessPayload,
  NotebookResource,
  NotebookSidebarPreference,
  NotebookType,
} from '@mode/notebooks/contract';
import { SocketSubscription } from '@mode/shared/data-access-socket';

export const createNotebook = createAction('[Notebook] Create Notebook', props<{ reportToken: string }>());

export const addNotebookResourcesOnSuccess = createAction(
  '[Notebook] Add Notebook Resources on success',
  props<{ notebookResource: NotebookResource }>()
);

export const addNotebookFailure = createAction('[Notebook] AddFailure', props<{ reportToken: string; error: Error }>());
export const updatePreference = createAction('UpdatePreference', props<{ params: NotebookSidebarPreference }>());

export const updateNotebookType = createAction(
  '[Notebook] Patch',
  props<{ notebookToken: string; notebookType: NotebookType }>()
);

export const run = createAction(
  '[Notebook] Run',
  props<{ notebookToken: string; runAllCells: boolean; cellTokensToRun: string[] }>()
);

export const cancelRun = createAction('[Notebook] CancelRun', props<{ notebookToken: string }>());
export const cancelRunComplete = createAction('[Notebook] CancelRunComplete', props<{ notebookToken: string }>());
export const cancelRunSuccess = createAction('[Notebook] CancelRunSuccess', props<{ notebookToken: string }>());

export const initSession = createAction(
  '[Notebook] InitSession',
  props<{
    notebookToken: string;
    reuseIfActive: boolean; // reuse an existing active session, if possible
    runNewCells?: boolean;
  }>()
);

export const clearAllCellOutputs = createAction(
  '[Notebook] Clear All Cell Outputs',
  props<{
    notebookToken: string;
  }>()
);

export const refreshSessionReportRun = createAction(
  '[Notebook] RefreshSessionReportRun',
  props<{
    notebookToken: string;
  }>()
);

export const initNotebook = createAction(
  '[Notebook] Init'
  // notebookToken: string; // TODO: Use token when UI supports multiple notebooks
);

export const toggleNotebookSidebar = createAction('ToggleNotebookSidebar');

//Old action names for reference
export const addNotebook = createAction('[Notebook] Add', props<{ reportToken: string }>());

export const terminated = createAction(
  '[[Notebook] Terminated',
  props<{ sessionToken: string; notebookToken: string; terminationReason: string }>()
);

export const importNotebook = createAction('[Notebook] ImportNotebook', props<{ file: File; reportToken?: string }>());

export const importNotebookFailure = createAction(
  '[Notebook] ImportNotebook Failure',
  props<{ error: string; message: string }>()
);

export const importNotebookCompleted = createAction(
  '[Notebook] ImportNotebook Completed',
  props<{ token: string; message?: string; state?: string; updated_at?: string; link?: string }>()
); // Pusher event success

export const importNotebookFailed = createAction(
  '[Notebook] ImportNotebook Failed',
  props<{ token: string; message?: string; state?: string; updated_at?: string }>()
); // Pusher event failed

export const importNotebookSocketConnectionSuccess = createAction(
  '[Import Notebook] Socket Connection Success',
  props<{
    importNotebookSubscription: SocketSubscription<ImportNotebookSocketSuccessPayload>;
  }>()
);

export const initiateSocketConnection = createAction(
  '[Import Notebook] Initiate Socket Connection',
  props<{
    pusherChannelName: string;
  }>()
);
